import { isEmpty } from 'lodash';
import selectors from '../../rootSelectors';
import { makeApiPostRequest, makeApiGetRequest } from './apiActions';
import { setResult } from './resultActions';
import RANServiceClient from '../clients/RANServiceClient';

export const postResult = (measureType, formId) => (dispatch, getStore) => {
    const state = getStore();
    const instId = selectors.getInstId(state, RANServiceClient.MEASURE);
    const postBody = {
        grade_level: selectors.getGrade(state),
        inst_uid: instId,
        period: selectors.getToy(state),
        school_year: selectors.getSchoolYear(state),
        student_uid: selectors.getUserId(state),
        student_temporal_id: selectors.getStudentTemporalId(state, instId) || undefined, // unset if not available
        time_duration: selectors.getRANTimeDuration(state),
        responses: selectors.getRANResponses(state),
        assessment_mode: 'online',
        assessment: RANServiceClient.NAME,
        measure: RANServiceClient.MEASURE,
        form_id: formId,
        measure_type: measureType,
    };

    const endpoint = RANServiceClient.constructPostResultEndpoint();
    return dispatch(makeApiPostRequest(endpoint, postBody));
};

export const getStudentResults = () => (dispatch, getStore) => {
    const state = getStore();
    const studentId = selectors.getUserId(state);
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);
    const schoolYear = selectors.getSchoolYear(state);
    const config = {
        studentId,
        grade,
        period,
        schoolYear,
    };
    const endpoint = RANServiceClient.constructResultListEndpoint(config);
    return dispatch(makeApiGetRequest(endpoint)).then(data => {
        const resultsData = isEmpty(data) ? [] : data.results;
        resultsData.forEach(resultData => {
            dispatch(setResult(resultData));
        });
    });
};
